import type { NavigateFunction } from 'react-router-dom';
import Logo from '../assets/logo.svg';
import LogoMerchant from '../assets/logo-merchant.svg';
import { appLinks } from '../config/appLinks';

export type LauncherApp = {
  key: 'ez-topup' | 'merchant' | 'family-plan' | 'auto' | 'coupon';
  name: string;
  subtitle: string;
  href: string;
  internal: boolean;
  logo: string;
};

const autoHostnames = new Set(['auto.eztopup.com.mm']);
const couponHostnames = new Set(['coupon.eztopup.com.mm']);

export const launcherApps: readonly LauncherApp[] = [
  {
    key: 'ez-topup',
    name: 'EZ Topup',
    subtitle: 'Main app',
    href: '/?openApp=ez-topup',
    internal: true,
    logo: Logo,
  },
  {
    key: 'merchant',
    name: 'EZ Merchant',
    subtitle: 'Merchant tools',
    href: '/?openApp=merchant',
    internal: true,
    logo: LogoMerchant,
  },
  {
    key: 'family-plan',
    name: 'Family Plan',
    subtitle: 'Family management',
    href: '/?openApp=family-plan',
    internal: true,
    logo: Logo,
  },
  {
    key: 'auto',
    name: 'EZ Auto Topup',
    subtitle: 'Scheduler workspace',
    href: appLinks.autoTopupUrl,
    internal: false,
    logo: `${appLinks.autoTopupUrl.replace(/\/+$/, '')}/ez-auto-topup-logo.png`,
  },
  {
    key: 'coupon',
    name: 'EZ Coupon Topup',
    subtitle: 'Campaign workspace',
    href: appLinks.couponTopupUrl,
    internal: false,
    logo: `${appLinks.couponTopupUrl.replace(/\/+$/, '')}/ez-coupon-topup-logo.png`,
  },
] as const;

export const openLauncherApp = (app: LauncherApp, navigate: NavigateFunction) => {
  if (app.internal) {
    navigate(app.href);
    return;
  }
  window.location.assign(app.href);
};

export const isCurrentLauncherApp = (
  app: LauncherApp,
  pathname: string,
  search: string,
  activeRole?: string,
  hostname = window.location.hostname,
) => {
  switch (app.key) {
    case 'ez-topup':
      return activeRole !== 'merchant' && !pathname.startsWith('/family-plan');
    case 'merchant':
      return activeRole === 'merchant' || search.includes('pg=merchant');
    case 'family-plan':
      return pathname.startsWith('/family-plan');
    case 'auto':
      return hostname.startsWith('dev.auto.') || autoHostnames.has(hostname);
    case 'coupon':
      return hostname.startsWith('dev.coupon.') || couponHostnames.has(hostname);
    default:
      return false;
  }
};
